import { estimateSurvey } from './estimate-survey';
import { toSellSurvey } from './to-sell-survey';
import { estimateSurveyV3 } from './estimate-survey-v3';
import { buyersSurvey } from './buyers-survey';
import { mortgageSurvey } from './mortgage-survey';

export const survey = {
  // survey cta
  'survey.next': 'Další',
  'survey.back': 'Zpět',

  // survey remidner
  'survey.reminder.button': 'Dokončit',
  'survey.reminder.close': 'zavřít',
  'survey.reminder.text1': 'Máte rozpracovanou žádost',
  'survey.reminder.text2':
    '. Dokončete ji a získejte bezplatnou cenovou nabídku.',

  'survey.search.no_results': 'Žádné výsledky',

  // META
  'survey.meta.title': 'Prodej nemovitosti bez starostí',
  'survey.form.submit': 'Chci bezplatnou nabídku',
  'survey.submit.error':
    'Při odesílání formuláře došlo k chybě. Zkuste to prosím znovu.',
  // SUCCESS
  'survey.success.title': 'Děkujeme',
  'survey.success.subtitle': 'Vaši poptávku jsme v&nbsp;pořádku přijali.',

  'survey.success.title.optional': 'Doplňující informace odeslány',
  'survey.success.subtitle.optional':
    'Než vás budeme kontaktovat, máme pro vás výběr toho nejlepšího z našeho blogu.',

  'survey.optional.subtitle':
    'Brzy se vám ozveme s&nbsp;nabídkou a&nbsp;navrhneme vám další postup.',
  'survey.optional.text':
    'Pro lepší zpracování vašeho požadavku nám pomůže znát odpověď týkající se financování vaší nemovitosti.',
  'survey.optional.estate_mortage': 'Čerpáte na nemovitost hypotéku?',
  'survey.optional.estate_mortage.yes': 'Ano',
  'survey.optional.estate_mortage.no': 'Ne',
  'survey.optional.estate_mortage_payment':
    'Kolik platíte měsíčně za hypotéku?',
  'survey.optional.submit': 'Odeslat doplňující informace',

  // --- fields ---
  // flat disposition
  'survey.field.flat_disposition.1+kk': '1+KK',
  'survey.field.flat_disposition.1+1': '1+1',
  'survey.field.flat_disposition.2+kk': '2+KK',
  'survey.field.flat_disposition.2+1': '2+1',
  'survey.field.flat_disposition.3+kk': '3+KK',
  'survey.field.flat_disposition.3+1': '3+1',
  'survey.field.flat_disposition.4+kk': '4+KK',
  'survey.field.flat_disposition.4+1': '4+1',
  'survey.field.flat_disposition.larger': 'Větší',

  // flat amenities
  'survey.field.flat_amenities.elevator': 'Výtah',
  'survey.field.flat_amenities.balcony': 'Balkon',
  'survey.field.flat_amenities.garage': 'Garáž',
  'survey.field.flat_amenities.parking_space': 'Park. stání',
  'survey.field.flat_amenities.cellar': 'Sklep',
  'survey.field.flat_amenities.loggia': 'Lodžie',
  'survey.field.flat_amenities.terrace': 'Terasa',
  'survey.field.flat_amenities.garden': 'Zahrada',
  'survey.field.flat_amenities.furnished': 'Zařízený byt',

  // flat ownership
  'survey.field.flat_ownership.private': 'Osobní',
  'survey.field.flat_ownership.collective': 'Družstevní',
  'survey.field.flat_ownership.national_or_municipal': 'Státní/obecní',
  'survey.field.flat_ownership.mixed': 'Smíšené',
  'survey.field.flat_ownership.other': 'Jiné',

  // floor numeric
  'survey.field.floor_numeric.flatFloor': 'Číslo podlaží bytu',
  'survey.field.floor_numeric.buildingFloors': 'Počet podlaží v budově',

  // yes no
  'survey.field.yes_no.yes': 'Ano',
  'survey.field.yes_no.no': 'Ne',

  // building finished numeric
  'survey.field.building_finished_at_numeric': 'Rok výstavby',

  ...estimateSurvey,
  ...toSellSurvey,
  ...estimateSurveyV3,
  ...buyersSurvey,
  ...mortgageSurvey,
};
